import { SignBorrowContactComponent } from "../../../components/borrowSystem/Contact/SignBorrowContactComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
export function SignBorrowContactContainer() {
  const titleName = "จัดทำสัญญา"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <SignBorrowContactComponent />
      <Footer />
    </div>
  );
}
